import Typography from '@mui/material/Typography';
import type { ReactElement, ReactNode } from 'react';

import { tokens } from '../../../design/tokens';

/**
 * Shared step heading — eyebrow + title + subtitle — used by PhoneStep,
 * OtpStep, and TotpStep so the right-column typography is consistent.
 *
 * Pulled out of the step bodies to keep each step component under the
 * 80-line max-lines-per-function lint cap.
 */
export type StepHeadingProps = {
  eyebrow: string;
  title: string;
  subtitle: string;
  children?: ReactNode;
};

export const StepHeading = ({
  eyebrow,
  title,
  subtitle,
  children,
}: StepHeadingProps): ReactElement => (
  <>
    <Typography
      sx={{
        fontSize: 11,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: 1.4,
        color: tokens.text.tertiary,
        mb: '14px',
      }}
    >
      {eyebrow}
    </Typography>
    <Typography
      component="h1"
      sx={{
        fontSize: 30,
        fontWeight: 700,
        lineHeight: '36px',
        letterSpacing: '-0.7px',
        color: tokens.text.primary,
        mb: '10px',
      }}
    >
      {title}
    </Typography>
    <Typography
      sx={{
        fontSize: 14,
        lineHeight: '22px',
        color: tokens.text.secondary,
        mb: '22px',
      }}
    >
      {subtitle}
    </Typography>
    {children}
  </>
);
